// SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
// Copyright (C) 2024 (original work) Open Assessment Technologies SA;
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License

import config from '@/config';
import { get } from 'svelte/store';
import { log } from '@/core/utils';
import { AuthError } from '@/errors';
import { featuresStore } from '@/stores/features.store';

/**
 * Guard determines whether a given feature flag is enabled or not
 * @param {string} featureFlag
 * @returns {Promise}
 */
export const getFeaturesGuard = featureFlag => (next, router) => {
    try {
        const featureStore = get(featuresStore);
        const isEnabled = featureStore.isFeatureEnabled(featureFlag);

        if (!isEnabled) {
            throw new AuthError('User is not allowed to access this page');
        }

        return next();
    } catch (err) {
        log.error(err);
        router.redirect(config.routes.error);
    }
};
